import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

interface DeleteRecommendationResponse {
  carePlan: fhirTypes.CarePlan;
  recommendation: fhirTypes.Task;
}

export const useDeleteRecommendation = ({
  encounterId,
  carePlanId,
  recommendationId,
}: {
  encounterId: string;
  carePlanId: string;
  recommendationId?: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<DeleteRecommendationResponse, void>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.VOID({
          patientId,
          encounterId,
          carePlanId,
        }),
      mutationFn: () => {
        return axiosInstance.delete(
          `/charting/careplan/${carePlanId}/recommendation/${recommendationId}`,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Recommendation.DEFAULT(
              {
                patientId,
                encounterId,
                carePlanId,
              },
            ),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
